import {AddIcon, CleanIcon} from "../../../../../components/buttons/IconButtons";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import DivContainerBody from "../../../../../components/DivContainerBody";
import React from "react";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import CreateEntryAndExitFormApp from "../../Functionality/EntryAndExitForms/CreateEntryAndExitFormApp";
import RequestInformationSection from "./RequestInformationSection";
import {ENTRY_AND_EXIT_FORMS} from "../../Model/Model";
import GeneralExitSections from "./GeneralEntryExit/GeneralExitSections";
import GeneralExitRequestInformationFields from "./GeneralEntryExit/GeneralExitRequestInformationFields";
import PlantMaterialControlRequestSections from "./PlantMaterialControl/PlantMaterialControlRequestSections";
import CratesAndPalletsReturnInformationFields from "./CratesAndPalletsReturn/CratesAndPalletsReturnInformationFields";
import CratesAndPalletsReturnSections from "./CratesAndPalletsReturn/CratesAndPalletsReturnSections";
import PoultryTruckExitInformationFields from "./PoultryTruckExit/PoultryTruckExitInformationFields";
import PoultryTruckExitSections from "./PoultryTruckExit/PoultryTruckExitSections";
import LivePoultryTruckSections from "./LivePoultryTruck/LivePoultryTruckSections";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreateEntryAndExitForm = ({userTypeId}) => {
    const {
        t,
        DEV,
        isGuard,
        permission,
        navigate,
        emptyFields,
        emptyFieldsItems,
        setEmptyFieldsItems,
        materialRequest,
        setMaterialRequest,
        handleChange,
        photoPicker,
        setPhotoPicker,
        selectedEmployees,
        setSelectedEmployees,
        watchers,
        setWatchers,
        responsibleDepartments,
        setResponsibleDepartments,
        formKey,
        resetForm,
        handleOnBack,
        handleAction
    } = CreateEntryAndExitFormApp({userTypeId});

    if (!DEV && !isGuard &&
        !permission?.includes(permissionObj.WEB_ENTRY_AND_EXIT_FORMS_READ) &&
        !permission?.includes(permissionObj.WEB_ENTRY_AND_EXIT_FORMS_CREATE)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'create'}
                onBack={handleOnBack}
                divStack={<>
                            <ButtonIcon
                                className='btn-clean-secondary-600'
                                id='btn_cea_clean_all_inputs'
                                Icon={CleanIcon}
                                title={'clear_instances'}
                                onClick={() => {
                                    resetForm();
                                }}
                            />
                            <CustomChip legend={t(ENTRY_AND_EXIT_FORMS[formKey].trans)}
                                        background={colors.secondary100}
                                        fontColor={colors.secondary700}
                                        borderColor={colors.secondary150}
                                        variant={'compact'}
                                        icon={ENTRY_AND_EXIT_FORMS[formKey].Icon}
                                        classNameIcon={'icon-color-secondary-700 h-16px w-16px'}
                            />
                        </>
                    }
                >
                { (DEV || permission?.includes(permissionObj?.WEB_ENTRY_AND_EXIT_FORMS_CREATE)) &&
                    <ButtonAction
                        id='btn_cea_create'
                        name={'create'}
                        className={'btn-icon-add'}
                        Icon={AddIcon}
                        onClick={() => {
                        handleAction();
                    }}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <RequestInformationSection
                    t={t}
                    idPrefix={'cea'}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    selectedEmployees={selectedEmployees}
                    setSelectedEmployees={setSelectedEmployees}
                    watchers={watchers}
                    setWatchers={setWatchers}
                    responsibleDepartments={responsibleDepartments}
                    setResponsibleDepartments={setResponsibleDepartments}
                >
                    { formKey === ENTRY_AND_EXIT_FORMS.GENERAL_ENTRY_EXIT.key ?
                        <GeneralExitRequestInformationFields
                            materialRequest={materialRequest}
                            handleChange={handleChange}
                        />
                        : formKey === ENTRY_AND_EXIT_FORMS.CRATES_AND_PALLETS_RETURN.key ?
                            <CratesAndPalletsReturnInformationFields
                                t={t}
                                materialRequest={materialRequest}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                            />
                            : formKey === ENTRY_AND_EXIT_FORMS.POULTRY_TRUCK_EXIT.key ?
                                <PoultryTruckExitInformationFields
                                    t={t}
                                    materialRequest={materialRequest}
                                    handleChange={handleChange}
                                    emptyFields={emptyFields}
                                />
                            : ''
                    }
                </RequestInformationSection>

                { formKey === ENTRY_AND_EXIT_FORMS.GENERAL_ENTRY_EXIT.key ?
                    <GeneralExitSections
                        emptyFields={emptyFields}
                        materialRequest={materialRequest}
                        setMaterialRequest={setMaterialRequest}
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        emptyFieldsItems={emptyFieldsItems}
                        setEmptyFieldsItems={setEmptyFieldsItems}
                    />
                    : formKey === ENTRY_AND_EXIT_FORMS.PLANT_MATERIAL_CONTROL.key ?
                        <PlantMaterialControlRequestSections
                            t={t}
                            handleChange={handleChange}
                            materialRequest={materialRequest}
                            setMaterialRequest={setMaterialRequest}
                            emptyFields={emptyFields}
                            emptyFieldsItems={emptyFieldsItems}
                            setEmptyFieldsItems={setEmptyFieldsItems}
                        />
                        : formKey === ENTRY_AND_EXIT_FORMS.CRATES_AND_PALLETS_RETURN.key ?
                            <CratesAndPalletsReturnSections
                                t={t}
                                handleChange={handleChange}
                                materialRequest={materialRequest}
                                emptyFields={emptyFields}
                            />
                            : formKey === ENTRY_AND_EXIT_FORMS.POULTRY_TRUCK_EXIT.key ?
                                <PoultryTruckExitSections
                                    t={t}
                                    handleChange={handleChange}
                                    materialRequest={materialRequest}
                                    emptyFields={emptyFields}
                                />
                                : formKey === ENTRY_AND_EXIT_FORMS.LIVE_POULTRY_TRUCK.key ?
                                    <LivePoultryTruckSections
                                        t={t}
                                        handleChange={handleChange}
                                        materialRequest={materialRequest}
                                        setMaterialRequest={setMaterialRequest}
                                        emptyFields={emptyFields}
                                    />
                                    : ''

                }
            </DivContainerBody>
        </>
    );
};

export default CreateEntryAndExitForm;
